import { render, staticRenderFns } from "./ResumeEducation.vue?vue&type=template&id=10742d59&scoped=true"
import script from "./ResumeEducation.vue?vue&type=script&lang=js"
export * from "./ResumeEducation.vue?vue&type=script&lang=js"
import style0 from "./ResumeEducation.vue?vue&type=style&index=0&id=10742d59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10742d59",
  null
  
)

export default component.exports